import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from './policy-cancellation.reducer';

export const selectPolicyCancellationState = createFeatureSelector<State>(featureKey);

export const getRethinkingCheckboxInd = createSelector(
  selectPolicyCancellationState,
  (state: State) => state.rethinkingCheckboxInd
);

export const getSaleCheckboxInd = createSelector(
  selectPolicyCancellationState,
  (state: State) => state.saleCheckboxInd
);

export const getCancellationReasonDesc = createSelector(
  selectPolicyCancellationState,
  (state: State) => state.cancellationReasonDesc
);
